export default {
    armUserName: 'mpenia',
    armUserPwd: 'GamcoTiene5Letras'
};